import Vue from 'vue';
import VueRouter from 'vue-router';
import App from './App.vue';
import Header from './Header.vue';
import Sidebar from './sidebar.vue';
import Manage_bar from './manage-bar.vue';
import Index from './index.vue';
import Privacypolicy from './privacy-policy.vue';
import Termsandconditions from './terms-and-conditions.vue';
import Disclaimer from './disclaimer.vue';
import Cookiepolicy from './cookie-policy.vue';
import Eula from './eula.vue';
import Retund_and_refund from './return-and-refund.vue';
import Websites from './websites.vue';
import Add_website from './add-website.vue';
import Edit_website from './edit-website.vue';
import Account_tabs from './account-tabs.vue';
import Account from './account.vue';
import Billing from './billing.vue';
import Edit_billing from './edit-billing.vue';
import VueHeadful from 'vue-headful';
import VueCookies from 'vue-cookies';

Vue.config.devtools = true;
Vue.use(VueRouter);
Vue.use(VueCookies);

const routes = [
  { name: 'index' ,path: '/dashboard/', component: Index },
  { name: 'index' ,path: '/dashboard/index', component: Index },
  { name: 'privacy-policy' ,path: '/dashboard/privacy-policy', component: Privacypolicy },
  { name: 'terms-and-conditions' ,path: '/dashboard/terms-and-conditions', component: Termsandconditions },
  { name: 'disclaimer' ,path: '/dashboard/disclaimer', component: Disclaimer },
  { name: 'cookie-policy' ,path: '/dashboard/cookie-policy', component: Cookiepolicy },
  { name: 'eula' ,path: '/dashboard/eula', component: Eula },
  { name: 'return-and-refund' ,path: '/dashboard/return-and-refund', component: Retund_and_refund },
  { name: 'websites' ,path: '/dashboard/websites', component: Websites },
  { name: 'add-website' ,path: '/dashboard/add-website', component: Add_website },
  { name: 'edit-website' ,path: '/dashboard/edit-website', component: Edit_website },
  { name: 'edit-website' ,path: '/dashboard/edit-website/:scriptid', component: Edit_website },
  { name: 'account' ,path: '/dashboard/account', component: Account },
  { name: 'billing' ,path: '/dashboard/billing', component: Billing },
  { name: 'edit-billing' ,path: '/dashboard/edit-billing', component: Edit_billing },
];

const router = new VueRouter({
  scrollBehavior() {
  return { x: 0, y: 0 };
},
routes,
mode: 'history'
});

Vue.component('app-header', Header);
Vue.component('sidebar-header', Sidebar);
Vue.component('manage-bar', Manage_bar);
Vue.component('account-header', Account_tabs);
Vue.component('vue-headful', VueHeadful);

var vm  = new Vue({
  el: '#app',
  router,
  render: h => h(App)
})
window.vm = vm;



// WEBPACK FOOTER //
// ./src/main.js